module.exports = __webpack_public_path__ + "static/7eyecatchingindiegamesPYG0-63ef3c9bb2fcc4e26d34ffa350d97a5e.png";